import {
  REFERRAL,
  SERVICE_CASE,
} from './eventConstants';

export default function getDetailDescriptionEvent(detailObj) {
  return detailObj._meta._type === 'cases_servicecase' ? SERVICE_CASE.descriptionUpdated : REFERRAL.descriptionUpdated;
}
